// Third-party imports
import $ from 'jquery';

// global arg is expected to be the window object when run in a browser
export function cartUpdateHandler(global) {
    updateCartQuantity(global, buildCounterDataObject.call(this));
    let quantityInputWrapper = $(this).closest('.quantityInput-wrapper');
    quantityInputWrapper.addClass('js-loading');
    quantityInputWrapper
        .find('.basketCard--loadingAnimationWrapper')
        .addClass('js-loading');
}

export function isCartUpdating() {
    let quantityInputWrapper = $(this).closest('.quantityInput-wrapper');
    return quantityInputWrapper.hasClass('js-loading');
}

// global arg is expected to be the window object when run in a browser
function updateCartQuantity(global, updatedCounterDataObject) {
    let { counterValue, variantID } = updatedCounterDataObject;
    let url = '/cart/update.js';
    let data = 'updates[' + variantID + ']=' + counterValue;
    let dataType = 'json';
    let success = null;
    // $.post(url, 'updates[' + variantID + ']=' + counterValue)
    $.post(url, data, success, dataType)
        .then(() => {
            global.location.reload();
        })
        .catch(data => {
            let err = {
                msg: `POST failed with url: ${url}`,
                data,
            };
            throw err;
        });
}

function buildCounterDataObject() {
    let componentWrapper = $(this).closest(
        '.js-quantityIncrementer-componentWrapper'
    );
    let counterElement = componentWrapper.find(
        '.js-quantityIncrementer-counter'
    );
    let counterValue = parseInt(counterElement.val());
    let variantID = counterElement.data('variantId');
    return { counterValue: counterValue, variantID: variantID };
}
